// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"35":"b020ed49","195":"7de68cb7","332":"2f460987","436":"0a44cc41","480":"1d1abb3e","569":"2a1156ca","637":"8141a7de","787":"1ed0c42c","900":"d4fbae16"}[chunkId] + ".chunk.js";
};